import { LanguageInput } from "../input/LanguageInput";
import { PHPResponse } from "../PHPResponse";
import { PHPAdress, PHPAdresses } from "../PHPAdress";
import { PHPRequest } from "../PHPRequest";
import { EmailInput } from "./UserSignUpRequest";

export class UserAccountCreationInput extends LanguageInput
{
  email:string;
  tokenID:string;
  userName:string;
  password:string;
}

export class UserCreateAccountRequest extends PHPRequest<PHPAdress,UserAccountCreationInput,PHPResponse>
{
  static readonly ADRESS = PHPAdresses.USER_CREATE_ACCOUNT;

  constructor(){ super( UserCreateAccountRequest.ADRESS ); }
}
